import { Fragment, FunctionComponent, useMemo } from 'react'

import styled, { css } from 'styled-components'

import Separator from '@components/ProgressBar/Separator'
import Step from '@components/ProgressBar/Step'
import { getPreparedSteps } from '@components/ProgressBar/utils'

interface ProgressBarProps {
  steps: string[]
  currentStepIndex: number
}

const Wrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing4 },
    },
  }) => css`
    display: flex;
    flex-direction: row;
    gap: ${spacing4};
    align-items: center;
    justify-content: center;
  `}
`

const ProgressBar: FunctionComponent<ProgressBarProps> = ({
  steps,
  currentStepIndex,
}) => {
  const preparedSteps = useMemo(
    () => getPreparedSteps({ steps, currentStepIndex }),
    [steps, currentStepIndex]
  )
  return (
    <Wrapper>
      {preparedSteps.map((step, index) => (
        <Fragment key={index + 1}>
          <Step {...step} orderNumber={index + 1} />
          {index !== steps.length - 1 && (
            <Separator isCompleted={step.isCompleted} />
          )}
        </Fragment>
      ))}
    </Wrapper>
  )
}

export default ProgressBar
